export const footerStyles = {
    mainContainer: {
        backgroundColor: '#3C5FA6',
        color: 'white',
        py: { xs: 2, sm: 4 },
        px: { xs: 2, sm: 6 },
        zIndex: 'auto',
        '& a': {
            textDecoration: 'none !important',
            paddingLeft: '0px !important',
            marginLeft: '0px !important',
            color: 'inherit',
            '&:hover': { textDecoration: 'underline !important' },
        },
    },
    bottomContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: { xs: 0.75, sm: 1.5 },
        mt: { xs: 2, sm: 3 },
        color: '#fff',
        textAlign: 'center',
        flexDirection: { xs: 'column', sm: 'row' }
    },
    subTitle: {
        mb: { xs: 1.25, sm: 2 },
        color: '#fff',
        fontWeight: 600,
    },
};
